import React, { useMemo } from "react";
import { API_PARAM } from "../../constants/apiParams";
import { useTranslation } from "react-i18next";
import {
  DateFormatter,
  SFDatagrid,
  SFPageContainer,
  SFAddIcon,
  SFActionBar,
  ACTION_BAR_ACTION_NAMES,
  ACTION_BAR_ACTION_TYPES,
  hasPermission,
} from "@sf-core";
import { GridNames } from "../../constants/gridConfig";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../constants/paths";
import { Claims } from "../../constants/claims";

const ExecutionFlows = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columnDefs = useMemo(
    () => [
      {
        headerName: t("executionFlowsScreen.executionFlowsGrid.idColumn"),
        field: "id",
        hide: true,
        filter: false,
      },
      {
        headerName: t("executionFlowsScreen.executionFlowsGrid.nameColumn"),
        field: "name",
        minWidth: 180,
        sortable: false,
      },
      {
        headerName: t("executionFlowsScreen.executionFlowsGrid.statusColumn"),
        field: "status",
        minWidth: 100,
      },
      {
        headerName: t(
          "executionFlowsScreen.executionFlowsGrid.parametersColumn"
        ),
        field: "parameters",
        minWidth: 180,
        filter: false,
      },
      {
        headerName: t(
          "executionFlowsScreen.executionFlowsGrid.startedByColumn"
        ),
        field: "startedBy",
        minWidth: 150,
      },
      {
        headerName: t(
          "executionFlowsScreen.executionFlowsGrid.startedAtColumn"
        ),
        field: "startedAt",
        filter: false,
        valueFormatter: DateFormatter,
        minWidth: 180,
      },
      {
        headerName: t("executionFlowsScreen.executionFlowsGrid.endedAtColumn"),
        field: "endedAt",
        filter: false,
        valueFormatter: DateFormatter,
        minWidth: 180,
      },
      {
        headerName: t("executionFlowsScreen.executionFlowsGrid.commentsColumn"),
        field: "comments",
        minWidth: 150,
        filter: false,
      },
    ],
    []
  );

  const messages = {
    addSuccess: t("executionFlowsScreen.messages.addSuccess"),
  };

  const handleNewExecutionFlow = () => {
    navigate(PATHS.ADMIN_EXECUTION_FLOW_ADD);
  };

  const actionDefs = [];
  if (hasPermission(Claims.AdminETLsAdd)) {
    actionDefs.push({
      name: ACTION_BAR_ACTION_NAMES.ADD,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: handleNewExecutionFlow,
      buttonProps: {
        label: t("executionFlowsScreen.addButton"),
        icon: <SFAddIcon />,
        variant: "primary",
        placement: "start",
      },
    });
  }

  return (
    <SFPageContainer disableGutters>
      <SFActionBar
        actionDefs={actionDefs}
        titleProps={{
          title: t("executionFlowsScreen.executionFlows"),
        }}
      />
      <SFDatagrid
        messages={messages}
        canDownload={false}
        columnDefs={columnDefs}
        gridName={GridNames.EXECUTION_FLOWS_GRID}
        datasourceUrl={API_PARAM.EXECUTION_FLOWS_GRID}
        filterValuesUrl={API_PARAM.EXECUTION_FLOWS_COL_FILTER}
      />
    </SFPageContainer>
  );
};

export default ExecutionFlows;
